module.exports = __webpack_public_path__ + "static/13-e6a968de8c2095f94f943e23be21489e.jpg";